import React from 'react';
import './style.scss';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';

const Item = (props) => {
  const { item } = props;

  const _text = item?.fields?.text;
  const _heading = item?.fields?.heading;
  const _image = item?.fields?.theme?.fields?.image;
  const _year = item?.fields?.year;

  const shouldRenderImage = !!_image?.value?.src;
  const shouldRenderTitle = !!_heading?.value && _heading !== '';
  const shouldRenderDescription = !!_text?.value && _text !== '';
  const shouldRenderYear = !!_year?.value && _year !== '';
  return (
    <div
      className={clsx(
        'auto',
        `theme-${item?.fields?.theme?.fields?.DropdownValue?.value?.toLowerCase()}`
      )}
    >
      {shouldRenderImage && (
        <>
          <div className="shape leftImage">
            <Image field={_image} />
          </div>
          <div className="shape rightImage">
            <Image field={_image} />
          </div>
        </>
      )}

      {shouldRenderTitle && (
        <div className="card-item-title">
          <Text field={_heading} />
        </div>
      )}
      {shouldRenderDescription && <RichText className="card-item-description" field={_text} />}
      {shouldRenderYear && <RichText className="card-item-year" field={_year} />}
    </div>
  );
};

export default Item;
